import {Drawer,Button} from 'antd';
import React, {Component} from 'react';
import API from "../Utils/API";
import NotificationUtil from "../Utils/NotificationUtil";
import CategoryForm from "./CategoryForm";

class CategoryDrawer extends Component {


    save = (e) => {
        const { form } = this.formRef.props;
        form.validateFields((err, values) => {
            if (err) { return; }

            API.post("productPrice/saveWebshopCategory",values).then(res => {
                form.resetFields();
                console.log("Ezt kell elmenteni: ",values)
                this.props.onClose(e,true);
                NotificationUtil(res.data);
            }).catch(() => {
                NotificationUtil({msg:"Hiba történt!",type:"error"});
                this.props.onClose(e,true);
            });
        });
    };

    constructor(props){
        super(props);
        this.state = {
            title: ""
        };
    }

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    open = () => {
            this.setState({title: "Új webshop kategória létrehozása"});
    };

    render() {
        return (
            <Drawer
                width={480}
                title={this.state.title}
                placement="right"
                closable={true}
                afterVisibleChange={this.open}
                onClose={this.props.onClose}
                visible={this.props.visible}
            >

                <CategoryForm  wrappedComponentRef={this.saveFormRef} />
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                    }}
                >
                    <Button onClick={this.props.onClose} style={{marginRight: 8}}>
                        Mégsem
                    </Button>
                    <Button onClick={this.save} type="primary">
                        Mentés
                    </Button>
                </div>
            </Drawer>
        );
    }
}

export default CategoryDrawer;

